(function () {
    const designWidth = 375
    document.body.style.fontSize = '14px'
    const setRem = () => {
        let htmlDom = document.getElementsByTagName('html')[0];
        htmlDom.style.fontSize = (window.innerWidth * 100 / designWidth) + 'px';
    }
    setRem()
    window.onresize = setRem
}())